module.exports = "fragment UserImageFragment on Image {\n  ...ImageFragment\n  createdAt\n}\n"